module.exports = __webpack_public_path__ + "media/3.94f585b7.mp3";